/**
 * Created by Ivan on 11.09.2026
 */

const StickersBook2Merge3Adapter = {
    SubscribeToEvents: function () {
        cleverapps.eventBus.on("stickers2_unit_clicked", (unit) => {
            cleverapps.focusManager.display({
                focus: "StickersUnitLibraryWindow",
                stack: true,
                action: function (f) {
                    new UnitsLibraryWindow(unit);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        });
    }
};

cleverapps.whenAllInitialized(() => StickersBook2Merge3Adapter.SubscribeToEvents());
